<template>
  <div>
    <!-- breadcrumb area end -->
     <div class="container" v-if="this.storeCustomer != undefined">
        <div class="row"><div class="col-24">Afspraak opmaken voor <strong>{{this.storeCustomer.FirstName}}  {{this.storeCustomer.LastName}}</strong></div></div>
    </div>

<div class="container">Kies een salon
  <template v-for="item in getCalendars">
       <div class="col-xs-24" style="background-color:rgb(250, 248, 248);margin-top:7px;padding-top:7px;min-height:69px;margin-bottom:10px;height: 100%;border-radius:10px">
            <div  style="float:left;word-wrap: break-word;font-weight:600;margin-left:5px">
                <span style="font-weight:600">{{item.UserName}}</span>
                <template><br><span style="font-size:12px;font-weight:400">{{getSalonAdres (item.Location)}}</span></template>
                </div>
                <div  style="float:right;width:50px;margin-right:10px">
                    <div class="product-btn" @click="navigate (item)"><a><i></i>&gt;</a></div>
                </div>
        </div>
  </template>
</div>

<div class="container">
        <div class="row"><div class="col-24" style="color:#696969;text-align:center"><a style="color:#696969;font-size:small" target="_blank" href="https://www.posworld.be">Powered by Posworld</a></div></div>
</div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import ProductList from '@/components/products/ProductList.vue';
  import CategoryList from '@/components/categories/CategoryList.vue';
  import myHttpApi from "@/api/myhttpapi";

  export default {
    name: 'home',
    components: {
      'product-list': ProductList,
      'category-list': CategoryList
    },
     data () {
      return {
        storeCustomer : undefined,
        calendars : [],
        fullPage: false
      }
    },
    created () {
      document.title = "Reserveer online bij " + Vue.$storeSettings.StoreName
    },
    methods: {
      navigate (item) {
        Vue.$selectedStore = item
        this.$router.push('/saloncategories');
      },
      navigateBack () {
        this.$router.go(-1);
      },
      getSalonAdres (locationname) {
         var arr = locationname.split (",");
         if (arr.length > 1) return arr[1];
         return locationname;
      }
    },
    computed: {
      getCalendars () {
         console.log ("loading calendars")
         this.calendars = this.$store.getters.allCalendars;
         return (this.calendars)
      }
    },
    watch: {
      '$route' (to, from) {
      
      }
    },
    mounted() {
      this.storeCustomer = Vue.$storeCustomer;
    },
   
  }
</script>



// WEBPACK FOOTER //
// src/pages/SingleSalon/SalonSelect.vue